import React, { useState, useEffect } from 'react'
import './timeline.css'
import { useTranslation } from "react-i18next";

import rS_1 from '../../../assets/imgs/sobre_mi/rS_1.png'
import rS_2 from '../../../assets/imgs/sobre_mi/rS_2.png'
import rS_3 from '../../../assets/imgs/sobre_mi/rS_3.png'
import rS_4 from '../../../assets/imgs/sobre_mi/rS_4.png'
import rS_4_movil from '../../../assets/imgs/sobre_mi/rS_4-movil.png'
import rS_5 from '../../../assets/imgs/sobre_mi/rS_5.png'
import rS_5_movil from '../../../assets/imgs/sobre_mi/rS_5-movil.png'
import rS_6 from '../../../assets/imgs/sobre_mi/rS_6.png'
import Rectangle from '../../../assets/imgs/sobre_mi/Rectangle.png'
import puntos from '../../../assets/imgs/sobre_mi/puntos.png'
import Vector_1 from '../../../assets/imgs/sobre_mi/Vector_1.png'
import Vector_2 from '../../../assets/imgs/sobre_mi/Vector_2.png'
import Elipse from '../../../assets/imgs/sobre_mi/Elipse.png'
import Punto_rojo from '../../../assets/imgs/sobre_mi/Punto_rojo.png'


import im1 from '../../../assets/imgs/sobre_mi/img_1.png'
import im2 from '../../../assets/imgs/sobre_mi/img_2.png'
import im3 from '../../../assets/imgs/sobre_mi/img_3.png'

const Timeline = () => {
    const [t, i18n] = useTranslation("sobre_mi");
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        // Función para manejar cambios en el tamaño de la pantalla
        const handleResize = () => {
            const isMobileQuery = window.matchMedia('(max-width: 898px)');
            setIsMobile(isMobileQuery.matches);
        };

        // Llama a handleResize cuando se monta el componente y suscríbete a cambios en el tamaño de la pantalla
        handleResize();
        window.addEventListener('resize', handleResize);

        // Limpia el evento de cambio de tamaño al desmontar el componente
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const isEnglish = i18n.language === 'en';

    const getLinkUrl = () => {
        if (isEnglish) {
            return isMobile
                ? 'https://www.ricardosalinas.com/Content/assets/documents/Semblanza-RBS-movil-EN.pdf'
                : 'https://www.ricardosalinas.com/Content/assets/documents/Semblanza-RBS-desktop-EN.pdf';
        } else {
            return isMobile
                ? 'https://www.ricardosalinas.com/Content/assets/documents/Semblanza-RBS-movil-ES.pdf'
                : 'https://www.ricardosalinas.com/Content/assets/documents/Semblanza-RBS-desktop-ES.pdf';
        }
    };

    return (
        <div class="SB_timeline">


            <div class="SB_escritorio">

                <img src={puntos} class="SB_timeline_puntos-1" />
                <img src={puntos} class="SB_timeline_puntos-2" />
                <img src={puntos} class="SB_timeline_puntos-3" />
                <img src={puntos} class="SB_timeline_puntos-4" />
                <img src={puntos} class="SB_timeline_puntos-5" />
                <img src={puntos} class="SB_timeline_puntos-6" />
                <img src={Vector_1} class="SB_timeline_vector-1" />
                <img src={Vector_2} class="SB_timeline_vector-2" />
                <img src={Elipse} class="SB_timeline_Elipse" />
                <img src={Punto_rojo} class="SB_timeline_Punto-rojo" />

                <div class="SB_timeline_apasionado">
                    <div class="SB_timeline_apasionado-txt">
                        <p class="SB_timeline_txt">{(t('timeline.apasionado_1'))}<span class="SB_timeline_txt-negritas">
                            {(t('timeline.apasionado_2'))}</span>
                            {(t('timeline.apasionado_3'))}</p>
                    </div>
                    <div class="SB_timeline_apasionado-img">
                        <img src={Rectangle} class="SB_timeline_apasionado-img-Rectangle" />
                        <img src={rS_1} class="SB_timeline_apasionado-img-RS" />
                    </div>
                </div>
                <div class="SB_timeline_defensor">
                    <div class="SB_timeline_defensor-img">
                        <img src={rS_2} />
                    </div>
                    <div class="SB_timeline_defensor-txt">
                        <p class="SB_timeline_txt">
                            {(t('timeline.defensor_1'))}<span class="SB_timeline_txt-negritas"> {(t('timeline.defensor_12'))}</span>
                            {(t('timeline.defensor_13'))}<span class="SB_timeline_txt-negritas"> {(t('timeline.defensor_3'))}</span>
                            {(t('timeline.defensor_2'))}
                        </p>
                    </div>
                </div>
                <div class="SB_timeline_foros">
                    <div class="SB_timeline_foros-txt">
                        <p class="SB_timeline_txt">
                            <div dangerouslySetInnerHTML={{ __html: (t('timeline.foros')) }} />
                        </p>
                    </div>
                    <div class="SB_timeline_foros-img">
                        <img src={Rectangle} alt="Rectangle Image" class="SB_timeline_foros-img-Rectangle" />
                        <img src={rS_3} alt="RS Image" class="SB_timeline_foros-img-RS" />
                    </div>
                </div>

                <div class="SB_timeline_futuro">
                    <div class="SB_timeline_futuro-img">
                        <img src={rS_4} class="SB_timeline_futuro-img-Laptop" />
                        <img src={rS_4_movil} class="SB_timeline_futuro-img-Movil" />
                    </div>
                    <div class="SB_timeline_futuro-txt">
                        <p class="SB_timeline_txt">
                            <div dangerouslySetInnerHTML={{ __html: (t('timeline.compromiso_1')) }} />
                        </p>
                    </div>
                </div>
                <div class="SB_timeline_conferencias">
                    <div class="SB_timeline_conferencias-txt">
                        <p class="SB_timeline_txt">
                            <div dangerouslySetInnerHTML={{ __html: (t('timeline.privilegio')) }} />
                        </p>
                    </div>
                    <div class="SB_timeline_conferencias-img">
                        <img src={rS_5} class="SB_timeline_conferencias-img-Laptop" />
                        <img src={rS_5_movil} class="SB_timeline_conferencias-img-Movil" />
                    </div>
                </div>
                <div class="SB_timeline_conclusion">
                    <div class="SB_timeline_conclusion-img">
                        <img src={Rectangle} class="SB_timeline_conclusion-img-Rectangle" />
                        <img src={rS_6} class="SB_timeline_conclusion-img-RS" />
                    </div>
                    <div class="SB_timeline_conclusion-txt">
                        <p class="SB_timeline_txt">
                            <div dangerouslySetInnerHTML={{ __html: (t('timeline.disfruto_1')) }} />
                        </p>
                    </div>
                </div>
            </div>



            <div class="SB_movil">


                <img src={puntos} class="SB_timeline_puntos-1" />
                <img src={puntos} class="SB_timeline_puntos-2" />
                <img src={puntos} class="SB_timeline_puntos-3" />
                <img src={puntos} class="SB_timeline_puntos-4" />
                <img src={puntos} class="SB_timeline_puntos-5" />
                <img src={puntos} class="SB_timeline_puntos-6" />
                <img src={Vector_1} class="SB_timeline_vector-1" />
                <img src={Vector_2} class="SB_timeline_vector-2" />
                <img src={Elipse} class="SB_timeline_Elipse" />
                <img src={Punto_rojo} class="SB_timeline_Punto-rojo" />


                <div class="SB_timeline_apasionado">
                    <div class="SB_timeline_apasionado-img">
                        <img src={Rectangle} class="SB_timeline_apasionado-img-Rectangle" />
                        <img src={rS_1} class="SB_timeline_apasionado-img-RS SB_tam_Img" />
                    </div>

                    <div class="SB_timeline_apasionado-txt">
                        <p class="SB_timeline_txt">
                            <div dangerouslySetInnerHTML={{ __html: (t('timeline.apasionado')) }} />
                        </p>
                    </div>

                </div>
                <div class="SB_timeline_defensor">
                    <div class="SB_timeline_defensor-img">
                        <img src={im1} />
                    </div>
                    <div class="SB_timeline_defensor-txt">
                        <p class="SB_timeline_txt">
                            <div dangerouslySetInnerHTML={{ __html: (t('timeline.defensor')) }} />
                        </p>
                    </div>
                </div>
                <div class="SB_timeline_foros">
                    <div class="SB_timeline_foros-txt">
                        <p class="SB_timeline_txt">
                            <div dangerouslySetInnerHTML={{ __html: (t('timeline.foros')) }} />
                        </p>
                    </div>
                    <div class="SB_timeline_foros-img">
                        <img src={Rectangle} class="SB_timeline_foros-img-Rectangle" />
                        <img src={rS_3} class="SB_timeline_foros-img-RS" /> </div>
                </div>
                <div class="SB_timeline_futuro">
                    <div class="SB_timeline_futuro-txt">
                        <p class="SB_timeline_txt">
                            <div dangerouslySetInnerHTML={{ __html: (t('timeline.compromiso_1')) }} />
                            {/* {(t('timeline.privilegio'))} */}
                        </p>



                    </div>

                    <div class="SB_timeline_futuro-txt2">




                        <p class="SB_timeline_txt">
                            <div dangerouslySetInnerHTML={{ __html: (t('timeline.privilegio')) }} />
                        </p>
                    </div>




                    <div class="SB_timeline_futuro-img">
                        <img src={rS_4} class="SB_timeline_futuro-img-Laptop" />
                        <img src={rS_4_movil} class="SB_timeline_futuro-img-Movil" />

                    </div>

                </div>
                <div class="SB_timeline_conferencias">
                    <div class="SB_timeline_conferencias-txt">
                        <p class="SB_timeline_txt">
                            <div dangerouslySetInnerHTML={{ __html: (t('timeline.privilegio')) }} />
                        </p>
                    </div>
                    <div class="SB_timeline_conferencias-img">
                        <img src={rS_5} class="SB_timeline_conferencias-img-Laptop" />
                        <img src={rS_5_movil} class="SB_timeline_conferencias-img-Movil" />
                    </div>
                </div>
                <div class="SB_timeline_conclusion">
                    <div class="SB_timeline_conclusion-img">
                        <img src={Rectangle} class="SB_timeline_conclusion-img-Rectangle" />
                        <img src={rS_6} class="SB_timeline_conclusion-img-RS" />
                    </div>
                    <div class="SB_timeline_conclusion-txt">
                        <p class="SB_timeline_txt">
                            <div dangerouslySetInnerHTML={{ __html: (t('timeline.disfruto_1')) }} />
                        </p>
                    </div>
                    
                </div>

            </div>



            <div class="SB_timeline_button">
                <a target="_blank" href={getLinkUrl()}>
                    <button> {(t('timeline.button'))} </button>
                </a>
            </div>

            <div className='sobremi-video'>
                <iframe src="https://www.youtube.com/embed/hkxBR19TJH8?si=YHn2tOOAVAtX_aIB" title="Nacimos para hacer historia!!!" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>

            </div>
            <div className='sobremi-video_mov'>
                <iframe src="https://www.youtube.com/embed/hkxBR19TJH8?si=YHn2tOOAVAtX_aIB" title="Nacimos para hacer historia!!!" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>

            </div>



        </div>
    )
}

export default Timeline
